import React from 'react';
import glamorous from 'glamorous';
import FaPencil from 'react-icons/lib/ti/pencil';
import FaTrash from 'react-icons/lib/ti/trash';
//import User from 'react-icons/lib/ti/user-outline';
//import Marker from 'react-icons/lib/ti/location-outline';
//import { ActionsCellRenderer } from '../../vendor/signal-widgets/components/table-cells'; 

const ActionCellRenderer = (props) => {
  const { actionHandler } = props.columnProps.rest;
  const linkStyle = {textDecoration: 'underline', color: '#acb5be', fontSize: 12};
  const markerStyle = {margin: '0 20 0 2', fontSize: 18};

  return (
    <glamorous.Div 
      css={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'space-around',
        fontWeight: 400,
        fontStyle: 'italic',          
      }}>
      {/*<p><a style={linkStyle}>Add Location <Marker style={markerStyle}/></a></p>  
      <p><a style={linkStyle}>Add User <User style={markerStyle}/></a></p>*/}    
      <p><a style={linkStyle} onClick={() => actionHandler('UPDATE', {...props.original, rowID: props.index})}>Edit Org <FaPencil style={markerStyle}/></a></p>    
      <p><a style={linkStyle} onClick={() => actionHandler('DELETE', {...props.original, rowID: props.index})}>Delete Org <FaTrash style={markerStyle}/></a></p>  
    </glamorous.Div>
  );
}

export const getColumns = (organizationType, actionHandler) => {

  return [
    {
      Header: organizationType + ' Name',
      accessor: "org_name",
      minWidth: 300,
      style: {
        minWidth: 300,
        display: 'flex'
      }
    },
    {
      Header: "FreightVerify ID",
      accessor: "fv_id",
      minWidth: 200,
      style: {
        minWidth: 200,
        display: 'flex'
      }
    },
    {
      Header: "# of Users",
      accessor: "no_of_user",
      minWidth: 150,
      style: {
        minWidth: 150,
        display: 'flex'
      }
    },
    {
      Header: "# of Locations",
      accessor: "no_of_location",
      minWidth: 150,
      style: {
        minWidth: 150,
        display: 'flex'
      }
    },
    {
      Header: "Actions",
      id: 'actionCell',
      minWidth: 400,
      style: {
        minWidth: 400,
        display: 'flex',
        justifyContent: 'center'
      },
      Cell: ActionCellRenderer,      
      getProps: () => {return { actionHandler }}
    }
  ];
};


// WEBPACK FOOTER //
// ./src/modules/organizations/OrganizationsColumns.js